const languages = {
	en: {
		value: 'en',
		label: 'English',
	},
};

export default languages;
